(function() {
  function track(eventName, data) {
    if (eventName === 'video_impression' || eventName === 'shop_grid_impression') {
      data = data || {};
      var impressionKey = eventName + '|' + (data.placement || window.location.pathname || 'page');
      window.__socialBroMediaImpressions = window.__socialBroMediaImpressions || {};
      if (window.__socialBroMediaImpressions[impressionKey]) return;
      window.__socialBroMediaImpressions[impressionKey] = true;
    }
    var payload = Object.assign({ event: eventName }, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    rememberSocialBroAssist(eventName, data);
  }
  function rememberSocialBroAssist(eventName, data) {
    if (['video_play', 'video_click_product', 'video_complete', 'shop_grid_open', 'shop_grid_click_product'].indexOf(eventName) === -1) return;
    data = data || {};
    var assist = {
      source: eventName.indexOf('shop_grid') === 0 ? 'shop_grid' : 'video_layer',
      event: eventName,
      product_id: String(data.product_id || '').slice(0, 64),
      asset_id: String(data.video_url || data.carousel_id || '').slice(0, 500),
      placement: String(data.placement || '').slice(0, 128),
      title: String(data.video_title || data.product_title || '').slice(0, 255),
      ts: String(Date.now())
    };
    if (!assist.product_id && !assist.asset_id) return;
    try {
      var raw = JSON.stringify(assist);
      window.sessionStorage && window.sessionStorage.setItem('osh_socialbro_assist', raw);
      document.cookie = 'osh_socialbro_assist=' + encodeURIComponent(raw) + '; path=/; max-age=1209600; SameSite=Lax';
    } catch (e) {}
  }
  function trackAndNavigate(event, eventName, data, url) {
    var href = url || (event && event.currentTarget && event.currentTarget.href) || '';
    if (!href || href === '#' || (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1))) {
      track(eventName, data);
      return;
    }
    if (event) event.preventDefault();
    var done = false;
    var go = function() {
      if (done) return;
      done = true;
      window.location.href = href;
    };
    var payload = Object.assign({ event: eventName, event_callback: go, event_timeout: 700 }, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
      window.setTimeout(go, 750);
    } else {
      go();
    }
  }
  function esc(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function ctaTitle(value) {
    var text = String(value || 'product').trim();
    if (text.length > 24) text = text.slice(0, 24).trim() + '...';
    return 'Shop ' + text;
  }
  function bindViewAllTracking(root) {
    root.querySelectorAll('[data-video-layer-view-all]').forEach(function(link) {
      link.addEventListener('click', function(event) {
        trackAndNavigate(event, 'video_view_all_click', { placement: 'homepage_video_layer', video_title: 'View all shoppable videos', product_id: '', variant_id: '', sku: '', video_url: '' });
      });
    });
  }
  function pauseOtherVideos(currentVideo) {
    document.querySelectorAll('[data-video-layer-homepage] video').forEach(function(video) {
      if (video !== currentVideo && !video.paused) {
        video.pause();
      }
    });
  }
  function bindProgressTracking(videoEl, common) {
    var fired = { 25: false, 50: false, 75: false, complete: false };
    videoEl.addEventListener('timeupdate', function() {
      if (!videoEl.duration || !isFinite(videoEl.duration)) return;
      var pct = (videoEl.currentTime / videoEl.duration) * 100;
      if (pct >= 25 && !fired[25]) { fired[25] = true; track('video_25_percent', common); }
      if (pct >= 50 && !fired[50]) { fired[50] = true; track('video_50_percent', common); }
      if (pct >= 75 && !fired[75]) { fired[75] = true; track('video_75_percent', common); }
      if (pct >= 95 && !fired.complete) { fired.complete = true; track('video_complete', common); }
    });
    videoEl.addEventListener('ended', function() {
      if (!fired.complete) {
        fired.complete = true;
        track('video_complete', common);
      }
    });
  }
  function init(root) {
    if (root.dataset.loaded === '1') return;
    root.dataset.loaded = '1';
    root.setAttribute('aria-busy', 'true');
    var trackEl = root.querySelector('[data-video-layer-homepage-track]');
    var loadingMarkup = trackEl.innerHTML;
    bindViewAllTracking(root);
    fetch(root.dataset.apiUrl, { credentials: 'omit' }).then(function(r) { return r.json(); }).then(function(json) {
      if (!json.ok || !json.videos || !json.videos.length) throw new Error('No videos available');
      var cards = document.createDocumentFragment();
      var mobileAutoplay = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var mobileObserver = mobileAutoplay && 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55 && entry.target.__videoLayerStart) {
            entry.target.__videoLayerStart();
            mobileObserver.unobserve(entry.target);
          }
        });
      }, { threshold: [0.55] }) : null;
      json.videos.forEach(function(video) {
        var item = document.createElement('article');
        item.className = 'video-layer-home-card';
        var image = video.product_image_url || '';
        var priceText = video.price_text || '';
        var price = (priceText || video.compare_at_price_text) ? '<div class="video-layer-home-card__price">' + (video.compare_at_price_text ? '<span class="video-layer-home-card__compare">' + esc(video.compare_at_price_text) + '</span>' : '') + (priceText ? '<span>' + esc(priceText) + '</span>' : '') + '</div>' : '';
        item.innerHTML = '<div class="video-layer-home-card__media" role="button" tabindex="0" aria-label="Play product video"><img loading="lazy" src="' + esc(video.thumbnail_url) + '" alt="' + esc(video.video_title || 'Product video') + '"><span class="video-layer-home-card__play">▶</span></div><div class="video-layer-home-card__meta">' + (image ? '<img class="video-layer-home-card__variant" loading="lazy" src="' + esc(image) + '" alt="">' : '<span></span>') + '<div><a class="video-layer-home-card__title" title="' + esc(video.video_title || 'Shop product') + '" href="' + esc(video.product_url) + '">' + esc(video.video_title || 'Shop product') + '</a>' + price + '</div></div>';
        var common = { product_id: video.product_id || '', variant_id: video.variant_id || '', sku: video.sku || '', video_url: video.video_url || '', video_title: video.video_title || '', placement: 'homepage_video_layer' };
        function startVideo() {
          var media = item.querySelector('.video-layer-home-card__media');
          var existing = media.querySelector('video');
          if (existing) {
            var soundButton = media.querySelector('.video-layer-home-card__sound');
            if (existing.muted && existing.dataset.firstTapUnmuted !== '1') {
              existing.dataset.firstTapUnmuted = '1';
              existing.muted = false;
              if (soundButton) soundButton.textContent = 'Mute';
              pauseOtherVideos(existing);
              existing.play();
              return;
            }
            if (existing.paused) {
              pauseOtherVideos(existing);
              existing.play();
            } else {
              existing.pause();
            }
            return;
          }
          var v = document.createElement('video');
          v.src = video.video_url;
          v.poster = video.thumbnail_url;
          v.muted = true;
          v.playsInline = true;
          v.loop = true;
          v.preload = 'metadata';
          v.dataset.firstTapUnmuted = '0';
          bindProgressTracking(v, common);
          media.innerHTML = '';
          media.appendChild(v);
          var sound = document.createElement('button');
          sound.className = 'video-layer-home-card__sound';
          sound.type = 'button';
          sound.textContent = 'Unmute';
          ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
            sound.addEventListener(type, function(event) {
              event.stopPropagation();
            });
          });
          sound.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            v.dataset.firstTapUnmuted = '1';
            v.muted = !v.muted;
            sound.textContent = v.muted ? 'Unmute' : 'Mute';
            pauseOtherVideos(v);
            v.play();
          });
          media.appendChild(sound);
          var shop = document.createElement('a');
          shop.className = 'video-layer-home-card__shop';
          shop.href = video.product_url;
          shop.textContent = ctaTitle(video.video_title || 'product');
          shop.addEventListener('click', function(event) {
            event.stopPropagation();
            trackAndNavigate(event, 'video_click_product', common);
          });
          media.appendChild(shop);
          pauseOtherVideos(v);
          v.play();
          track('video_play', common);
        }
        var mediaButton = item.querySelector('.video-layer-home-card__media');
        mediaButton.__videoLayerStart = startVideo;
        mediaButton.addEventListener('mouseenter', startVideo, { once: true });
        mediaButton.addEventListener('click', startVideo);
        mediaButton.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            startVideo();
          }
        });
        if (mobileObserver) {
          mobileObserver.observe(mediaButton);
        }
        item.querySelectorAll('a').forEach(function(a) {
          a.addEventListener('click', function(event) { trackAndNavigate(event, 'video_click_product', common); });
        });
        cards.appendChild(item);
        track('video_impression', common);
      });
      trackEl.replaceChildren(cards);
      root.classList.remove('is-loading', 'is-unavailable');
      root.setAttribute('aria-busy', 'false');
      root.hidden = false;
    }).catch(function() {
      root.classList.remove('is-loading');
      root.classList.add('is-unavailable');
      root.setAttribute('aria-busy', 'false');
      trackEl.innerHTML = loadingMarkup + '<p class="video-layer-homepage__fallback" role="status">Browse our <a href="/videos/">product video library</a>.</p>';
      trackEl.scrollLeft = 0;
    });
  }
  document.querySelectorAll('[data-video-layer-homepage]').forEach(init);
})();
